import { useContext, useState } from 'react';
import { useCallback } from 'react';
import { HimmaContext } from '../context/HimmaContext';
import {
  DeleteSubAdminsRequest,
  DynamicHomePageContentSettings,
  ToggleSubAdminStatusRequest,
} from '../client-sdk/api';

export const useBannerApi = () => {
  const api = useContext(HimmaContext)!;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const createBanner = useCallback(
    async (choiceData: DynamicHomePageContentSettings) => {
      setLoading(true);
      setError(null);
      try {
        const response = await api.addBannerImageSettings(choiceData);
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  const getToggleStatus = useCallback(
    async (query: any) => {
      setLoading(true);
      setError(null);
      try {
        const toggleSubAdminStatusRequest: ToggleSubAdminStatusRequest = {
          ids: Array.isArray(query.id) ? query.id : [query.id],
          status: query.status,
        };
        const response = await api.toggleBannerImageStatus(
          toggleSubAdminStatusRequest
        );
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  const deleteBanner = useCallback(
    async (query: any) => {
      setLoading(true);
      setError(null);
      try {
        const deleteSubAdmins: DeleteSubAdminsRequest = {
          ids: query,
        };
        console.log('deleteSubAdmins', query);
        const response = await api.deleteHomePageBanner(deleteSubAdmins);
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  const editBanner = useCallback(
    async (id: any, subAdminData: DynamicHomePageContentSettings) => {
      console.log('ids322', id);
      setLoading(true);
      setError(null);
      try {
        const response = await api.editHomePageBanner(id, subAdminData);
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  const getAllBanner = useCallback(
    async (query: any) => {
      setLoading(true);
      setError(null);
      try {
        // Only include search parameter if it has a value
        // const searchParam =
        //   query.search && query.search.trim() !== '' ? query.search : undefined;
        const searchParam =
          query.search?.trim() !== '' ? query.search.trim() : undefined;
        console.log('reponsequery', query);
        const response = await api.getAllBannerImages(
          query.page,
          query.limit,
          query.sortBy,
          query.sortOrder,
          searchParam
        );
        console.log('reponsebanner', response);
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  return {
    createBanner,
    getAllBanner,
    getToggleStatus,
    deleteBanner,
    editBanner,
    loading,
    error,
  };
};
